const $onReady = require('public/js/lib/on-ready');

const getSearchBox = () =>
	import(/* webpackChunkName: "get-search-box" */ 'public/js/components/search-box');

const handleSearchBox = () => {
	const searchBoxForm = rp$('form.search-box');
	if (searchBoxForm.length === 0) {
		return;
	}
	getSearchBox()
		.then((module) => {
			module.default.setupSearchBox();
		})
		.catch((error) => {
			rp_app.logger.error({
				message: 'Failed to load search box',
				error: error,
				listener: 'get-search-box',
			});
		});
};

$onReady({
	rp$,
	window: globalThis,
	label: 'get-search-box',
	fn: handleSearchBox,
});
